import { render, staticRenderFns } from "./SetExtension.vue?vue&type=template&id=56300342&"
import script from "./SetExtension.vue?vue&type=script&lang=js&"
export * from "./SetExtension.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports